import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, MailCheck } from "lucide-react";
import { MobileShell } from "@/components/MobileShell";
import { Wordmark, Button, Field, Input } from "@/components/kit";
import { api, formatApiError } from "@/lib/api";

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <MobileShell>
      <div className="px-7 pt-6 pb-10 min-h-screen flex flex-col">
        <button onClick={() => navigate("/login")} className="text-[#5F6D66] -ml-2 p-2 w-fit" data-testid="forgot-back-btn">
          <ChevronLeft className="h-5 w-5" />
        </button>
        <div className="mt-6 lg:mt-2"><Wordmark className="lg:hidden" /></div>

        {sent ? (
          <div className="mt-16 text-center animate-rise" data-testid="forgot-sent-message">
            <div className="mx-auto h-14 w-14 rounded-full bg-[#F1EEE7] flex items-center justify-center">
              <MailCheck className="h-7 w-7 text-[#253B35]" strokeWidth={1.6} />
            </div>
            <h1 className="font-serif text-2xl text-[#1F2B26] mt-6">Check your inbox</h1>
            <p className="font-sans text-sm text-[#5F6D66] mt-3 leading-relaxed">
              If an account exists for <span className="text-[#1F2B26]">{email}</span>, we've sent a link to reset your password. It expires in one hour.
            </p>
            <Button variant="outline" className="mt-8" onClick={() => navigate("/login")} data-testid="forgot-return-btn">Return to sign in</Button>
          </div>
        ) : (
          <>
            <h1 className="font-serif text-3xl text-[#1F2B26] mt-8">Reset password</h1>
            <p className="font-sans text-sm text-[#5F6D66] mt-2">Enter your email and we'll send a reset link.</p>
            <form onSubmit={submit} className="mt-8 space-y-4">
              <Field label="Email">
                <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" data-testid="forgot-email-input" />
              </Field>
              {error && <p className="font-sans text-sm text-[#9B4B45]">{error}</p>}
              <Button type="submit" className="w-full" size="lg" disabled={loading} data-testid="forgot-submit-btn">
                {loading ? "Sending…" : "Send reset link"}
              </Button>
            </form>
          </>
        )}
      </div>
    </MobileShell>
  );
}
